import { createSlice } from "@reduxjs/toolkit";

const DEFAULT_PAGE_SIZE = 100;

const initialState = {
  partiesData: {
    results: [],
  },
  loading: false,
  error: null,
  pagination: {
    page: 1,
    skip: 0,
    take: DEFAULT_PAGE_SIZE,
    rows: DEFAULT_PAGE_SIZE,
    total: 0,
  },
  lastRequestParams: {},
};

const partiesSlice = createSlice({
  name: "parties",
  initialState,
  reducers: {
    // Handle parties fetch
    fetchPartiesRequest: (state, _action) => {
      state.loading = true;
      state.error = null;
    },
    fetchPartiesSuccess: (state, action) => {
      const { data = {}, metadata = {}, params = {} } = action.payload || {};
      
      // Validate and extract results array
      const results = Array.isArray(data?.results) ? data.results : [];
      
      // Determine total count from available sources
      let total = results.length;
      if (typeof metadata.total === "number") {
        total = metadata.total;
      } else if (typeof data.total === "number") {
        total = data.total;
      }

      const pageNumber = metadata.page || params.page_number || 1;
      const pageSize = metadata.pageSize || params.page_size || DEFAULT_PAGE_SIZE;

      state.partiesData = {
        results,
        total: data.total,
      };
      
      state.pagination = {
        page: pageNumber,
        pageSize,
        skip: (pageNumber - 1) * pageSize,
        take: pageSize,
        rows: results.length,
        total,
      };
      
      state.lastRequestParams = params;
      state.loading = false;
      state.error = null;
    },
    fetchPartiesFailure: (state, action) => {
      state.error = action.payload || "Failed to fetch parties";
      state.loading = false;
      state.partiesData = { results: [] };
    },

    // Handle delete parties
    deletePartyRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deletePartySuccess: (state, action) => {
      const { id } = action.payload;
      state.partiesData.results = state.partiesData.results.filter(
        (p) => p.party_id !== id
      );
      state.loading = false;
      state.error = null;
    },
    deletePartyFailure: (state, action) => {
      // state.error = action.payload || "Failed to delete party";
      state.loading = false;
    },

    // Handle Activate Deactivate Party
    activateDeactivatePartyRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    activateDeactivatePartySuccess: (state, action) => {
      const { id, flag } = action.payload;
      const party = state.partiesData.results.find((p) => p.party_id === id);
      if (party) party.is_active = flag;
      state.loading = false;
      state.error = null;
    },
    activateDeactivatePartyFailure: (state, action) => {
      // state.error = action.payload || "Failed to update party status";
      state.loading = false;
    },

    // Handle save (create/edit) party — success closes panel, failure shows toast
    savePartySuccess: (state) => {
      state.saveSuccess = true;
      state.saveError = null;
    },
    savePartyFailure: (state, action) => {
      state.saveError = action.payload || "Failed to save party";
      state.saveSuccess = false;
    },
    clearSaveStatus: (state) => {
      state.saveSuccess = false;
      state.saveError = null;
    },

    //Clear parties data and error state
    clearPartiesState: (state) => {
      state.partiesData = { results: [] };
      state.loading = false;
      state.error = null;
      state.pagination = initialState.pagination;
      state.lastRequestParams = {};
    },
  },
});

export const {
  fetchPartiesRequest,
  fetchPartiesSuccess,
  fetchPartiesFailure,
  deletePartyRequest,
  deletePartySuccess,
  deletePartyFailure,
  activateDeactivatePartyRequest,
  activateDeactivatePartySuccess,
  activateDeactivatePartyFailure,
  savePartySuccess,
  savePartyFailure,
  clearSaveStatus,
  clearPartiesState,
} = partiesSlice.actions;

export default partiesSlice.reducer;
